export default __webpack_public_path__ + "images/acp-avatar-guest-3b1db3.png";